/**
 * Active buffer language (status bar + Language menu; lexer parity is WEB/TBD).
 * Command IDs align with `menuCmdID.h` / PROJECT_SOURCE_CODE_DESCRIPTION.md §17.x language IDs.
 *
 * `LANGUAGE_MODE_LABELS` is the canonical UI string for each mode (status bar + menu).
 */
export const LANGUAGE_MODE_LABELS = {
  text: "Normal text",
  c: "C",
  cpp: "C++",
  cs: "C#",
  java: "Java",
  /** HTML markup; editor shows a sanitized live preview beside source (see AppShell). */
  html: "HTML",
  xml: "XML",
  js: "JavaScript",
  ts: "TypeScript",
  php: "PHP",
  python: "Python",
  json: "JSON",
  yaml: "YAML",
  css: "CSS",
  sql: "SQL",
  bash: "Bash",
  powershell: "PowerShell",
  ruby: "Ruby",
  go: "Go",
  rust: "Rust",
  r: "R",
  lua: "Lua",
  perl: "Perl",
  ini: "Ini file",
  makefile: "Makefile",
  props: "Properties",
  md: "Markdown",
  /** LaTeX / TeX source (.tex); preview uses KaTeX for `\\(…\\)`, `\\[…\\]`, `$$…$$`. */
  tex: "TeX / LaTeX",
  /** OEIS sequence reference; preview loads oeis.org JSON (via same-origin proxy). */
  oeis: "OEIS sequence",
  /** Max: prose + `$$…$$` TeX (KaTeX) + `@@…@@` math (functions, sums, `;`, `name = expr`, vars carry across blocks). */
  max: "Max",
  csv: "CSV",
  /** Editable grid + JSON buffer; `.xls`/`.xlsx`/`.xlsm` import and `.xlsx` export. */
  excel: "Excel",
  /** PDF document; binary preview uses `viewMode: "pdf"` (pdf.js). */
  pdf: "PDF",
  diff: "Diff",
  linuxobj: "Linux object",
} as const;

export type LanguageMode = keyof typeof LANGUAGE_MODE_LABELS;

/** Every mode key (for exhaustive tests / iteration). */
export const ALL_LANGUAGE_MODES: readonly LanguageMode[] = Object.keys(
  LANGUAGE_MODE_LABELS,
) as LanguageMode[];

export function languageLabel(mode: LanguageMode): string {
  return LANGUAGE_MODE_LABELS[mode];
}
